/**
 * 登録の画面（/signup）が開かれたことを 1 回だけ知らせる包み（2026-10-18 ops/gaps-activity・signupOpen.ts）。
 * WHY 画面の中ではなくルートで包むか: 旗 oneAccount が on のとき /signup はすぐ /login へ移り、search（invite・src）も落ちる
 *   = SignupPage の中で数えると、その形では 1 回も数えられない。ルートで最初の search を読めば、どちらの形でも同じに数えられる。
 * 最初の描画の search を覚える（AuthPage がすぐ URL から invite を消すため）。
 */
import { useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { reportSignupOpen } from '../onboardingReport';

export function SignupOpened({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [search] = useState(() => location.search);
  useEffect(() => reportSignupOpen(search), [search]);
  return <>{children}</>;
}
